import { Tab, Typography, Box } from '@mui/material';
import * as React from 'react';

export interface TitleTotalTabProps {
  title: string;
  key: string;
  total?: number;
  sequence: number;
  disabled?: boolean;
  visible?: boolean;
}

export const TitleTotalTab = ({ title, total }: TitleTotalTabProps) => {
  return (
    <Box sx={{ textAlign: 'left', whiteSpace: 'nowrap' }}>
      <Typography variant="body1" id="tableTitle" component="span">
        {title}&nbsp;<small>({total})</small>
      </Typography>
      {/* <Typography variant="subtitle2" id="tablesubtitle" component="span">
        ({total})
      </Typography> */}
    </Box>
  );
};
